import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { AdvancePaymentCaptureTable } from 'src/app/models/tables/wallet/advance-payment-capture-table.model';
import { CashReceiptPaymentCaptureTableModel } from 'src/app/models/tables/wallet/cash-receipt-payment-capture-table.model';
import { CashReceiptPaymentModel } from 'src/app/models/wallet/cash-receipt-payment.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CashReceiptPaymentService {

  constructor(private _httpClient: HttpClient) { }

  createCashReceiptPayment(cashReceiptId: number, cashReceiptPaymentContract: CashReceiptPaymentModel): Observable<CashReceiptPaymentModel> {
    return this._httpClient.post<CashReceiptPaymentModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceiptPayment.CreateCashReceiptPayment}/${cashReceiptId}`,
      cashReceiptPaymentContract);
  }

  deleteCashReceiptPayment(cashReceiptPaymentId: number): Observable<CashReceiptPaymentModel> {
    return this._httpClient.delete<CashReceiptPaymentModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceiptPayment.DeleteCashReceiptPayment}/${cashReceiptPaymentId}`);
  }

  exportCashReceiptPaymentsConsultation(isChargeAccount: boolean, filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceiptPayment.ExportCashReceiptPaymentsConsultation}/${isChargeAccount}`, filters, {
      params, responseType: 'blob',
    });
  }

  getAdvancePaymentsByCashReceiptId(cashReceiptId: number): Observable<CashReceiptPaymentModel> {
    return this._httpClient.get<CashReceiptPaymentModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceiptPayment.GetAdvancePaymentsByCashReceiptId}/${cashReceiptId}`);
  }

  getAdvancePaymentsAppliedByCashReceiptId(cashReceiptId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean): Observable<PagedResponseModel<AdvancePaymentCaptureTable>> {
    const params = new HttpParams().set('cashReceiptId', cashReceiptId).set('page', page).set('limit', limit).set('columnSort', columnSort || '')
      .set('ascendant', ascendant);

    return this._httpClient.get<PagedResponseModel<AdvancePaymentCaptureTable>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceiptPayment.GetAdvancePaymentsAppliedByCashReceiptId}`,
      { params: params }
    );
  }

  getAllCashReceiptPaymentsWithPagination(isChargeAccount: boolean, page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceiptPayment.GetAllCashReceiptPaymentsWithPaginationAsync}/${isChargeAccount}`,
      filters, { params: params }
    );
  }

  getAllWayToPaysForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceiptPayment.GetAllWayToPaysForSelectAsync}`,);
  }

  getCashReceiptPaymentById(cashReceiptPaymentId: number): Observable<CashReceiptPaymentModel> {
    return this._httpClient.get<CashReceiptPaymentModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceiptPayment.GetCashReceiptPaymentById}/${cashReceiptPaymentId}`);
  }

  getCashReceiptPaymentByKeys(cashReceiptId: number, wayToPayId: number): Observable<CashReceiptPaymentModel> {
    return this._httpClient.get<CashReceiptPaymentModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceiptPayment.GetCashReceiptPaymentByKeys}/${cashReceiptId}/${wayToPayId}`);
  }

  getCashReceiptPaymentsByCashReceiptId(cashReceiptId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean): Observable<PagedResponseModel<CashReceiptPaymentCaptureTableModel>> {
    const params = new HttpParams().set('cashReceiptId', cashReceiptId).set('page', page).set('limit', limit).set('columnSort', columnSort || '')
      .set('ascendant', ascendant);

    return this._httpClient.get<PagedResponseModel<CashReceiptPaymentCaptureTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceiptPayment.GetCashReceiptPaymentsByCashReceiptId}`,
      { params: params }
    );
  }

  getColumnsForCaptureTable(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceiptPayment.GetColumnsForCaptureTableAsync}`);
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceiptPayment.GetColumnsForGeneralConsultationAsync}`);
  }

  updateCashReceiptPayment(cashReceiptPaymentContract: CashReceiptPaymentModel): Observable<CashReceiptPaymentModel> {
    return this._httpClient.put<CashReceiptPaymentModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.cashReceiptPayment.UpdateCashReceiptPayment}`,
      cashReceiptPaymentContract);
  }

}
